import { Injectable } from '@angular/core';
import { IAppConfig } from '../interfaces/app-config';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'src/app/services/app-config.service';
import {
  IHMSDashboardResponse,
  IHMSResponse,
} from '../interfaces/ihms-dashboard-response';
import { BehaviorSubject, catchError, Observable } from 'rxjs';
import { handleError } from '../functions/error-handler';
import { ApiResponse } from '../interfaces/api-response';
import { IIhmsSavePayload } from '../interfaces/ihms-save-payload';
// import { SaveIhmsData } from '../models/ihms-save';
import { ICompleteActionPayload } from '../interfaces/complete-action-payload';
import { IIhmsEventLog } from '../interfaces/ihms-events-response';

@Injectable({
  providedIn: 'root',
})
export class IhmsService {
  config: IAppConfig;
  private reloadIhmsGrid: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  reloadIhmsGridData$: Observable<boolean> = this.reloadIhmsGrid.asObservable();
  loadingEvents: boolean = false;
  loadingIhmsActions: boolean = false;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  public getIHMSDashboardGrid(
    cpseDistrictId: string
  ): Observable<IHMSDashboardResponse> {
    return this.http
      .get<IHMSDashboardResponse>(
        `${this.config.apiUrl}/IHMS/GetIHMSDashboardData/${cpseDistrictId}`
      )
      .pipe(catchError(handleError));
  }

  public getIHMSStudentData(
    nycId: string,
    cpseDistrictId?: string
  ): Observable<IHMSResponse> {
    void cpseDistrictId;
    return this.http
      .get<IHMSResponse>(
        `${this.config.apiUrl}/IHMS/GetIHMSStudent/${nycId}`
      )
      .pipe(catchError(handleError));
  }

  public saveIhmsData(
    payload: IIhmsSavePayload
  ): Observable<ApiResponse<IIhmsSavePayload>> {
    return this.http
      .post<ApiResponse<IIhmsSavePayload>>(
        `${this.config.apiUrl}/IHMS/SaveIHMSData`,
        payload
      )
      .pipe(catchError(handleError));
  }

  getReloadIhmsGridDetails(data: boolean): void {
    this.reloadIhmsGrid.next(data);
  }

  getEventLogs(nycId: string, type: string): Observable<IIhmsEventLog[]> {
    void type;
    return this.http
      .get<IIhmsEventLog[]>(
        `${this.config.apiUrl}/IHMS/GetEventsLog/${nycId}`
      )
      .pipe(catchError(handleError));
  }

  completeActionItem(
    payload: ICompleteActionPayload
  ): Observable<ApiResponse<IIhmsSavePayload>> {
    return this.http
      .post<ApiResponse<IIhmsSavePayload>>(
        `${this.config.apiUrl}/IHMS/CompleteIHMS`,
        payload
      )
      .pipe(catchError(handleError));
  }
}
